var map = {
	"./coin_dime.svg": "1abe",
	"./coin_dimes.svg": "842d",
	"./coin_nickel.svg": "763b",
	"./coin_nickels.svg": "837b",
	"./coin_pennies.svg": "0c6e",
	"./coin_penny.svg": "c507",
	"./coin_quarter.svg": "bf34",
	"./coin_quarters.svg": "bf90"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8150";